/**
 * Lucide icon registry.
 *
 * The agent tool catalog (mono.agenttools.v1) carries `lucide_icon` as a
 * plain string ("FileSearch", "ClipboardList", ...) because proto can't
 * transport function-valued JS imports. This registry maps those strings
 * back to the imported icon components.
 *
 * Add new icons here when a sidecar YAML starts referencing them — the
 * tree-shaken bundle only includes icons listed in this file, so the catch
 * for missing icons is a runtime undefined lookup, not a bundle bloat.
 */ import { Award, BookOpen, Box, Building, CheckCircle, Cherry, ClipboardCheck, ClipboardList, Code, Database, DollarSign, Download, File, FileSearch, FileSpreadsheet, FileText, FolderOpen, Globe, Hammer, Hash, Network, Package, Pencil, Play, Scale, ScanLine, Search, Settings, Sparkles, Tag, Target, Terminal, Users, Wrench } from 'lucide-react';
/**
 * Map of lucide-react icon name (as imported) → component.
 *
 * Keep entries sorted alphabetically — easier to diff when new icons land.
 */ export const ICONS = {
    Award,
    BookOpen,
    Box,
    Building,
    CheckCircle,
    Cherry,
    ClipboardCheck,
    ClipboardList,
    Code,
    Database,
    DollarSign,
    Download,
    File,
    FileSearch,
    FileSpreadsheet,
    FileText,
    FolderOpen,
    Globe,
    Hammer,
    Hash,
    Network,
    Package,
    Pencil,
    Play,
    ScanLine,
    Scale,
    Search,
    Settings,
    Sparkles,
    Tag,
    Target,
    Terminal,
    Users,
    Wrench
};
/**
 * Resolve a lucide icon name from the catalog's display.lucide_icon string.
 * Returns `undefined` for unknown names so callers can fall back to their
 * own default (typically the baked-in tool-config icon, then a generic
 * Sparkles).
 */ export function iconByName(name) {
    if (!name) return undefined;
    return ICONS[name];
}
